export type ErrorsTranslations = {
  basic: {
    title: string
  }
  inactive: {
    title: string
    subMessage: string
  }
  buttons: {
    back: string
  }
};

export const errorsTranslations: ErrorsTranslations = {
  basic: {
    title: "Ups! Coś poszło nie tak",
  },
  inactive: {
    title: "Ups! Link stracił ważność.",
    subMessage: 'Wróć na stronę główną i zarejestruj się ponownie.'
  },
  buttons: {
    back: 'Wróć'
  }
};
